<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <div
    class="pb-0"
    style="height: 100%"
  >
    <div
      class="mt-4 flex-grow-1"
      style="overflow-y: scroll"
    >
      <div class="text-body-2 ml-8">
        {{ $t('chooseList') }}
      </div>
      <div class="ml-8 text-caption  mb-2">
        {{ $t('changePriceAndNameWillChangeAllGroup') }}
      </div>
      <draggable
        v-model="realList"
        handle=".handle"
      >
        <div
          v-for="a in realList"
          :key="a[itemId]"
          class="d-flex align-center mb-2"
        >
          <v-icon
            class="handle mr-4"
          >
            mdi-drag
          </v-icon>
          <v-text-field
            v-model="a.name"
            :placeholder="$t('enterAGName')"
            dense
            hide-details
            outlined
          />
          <div style="width: 16px"/>
          <div style="width: 120px">
            <v-text-field
              v-model="a.priceMod"
              append-icon="mdi-cash"
              dense
              hide-details
              outlined
              step="0.01"
              type="number"
            />
          </div>
          <template>
            <div style="width: 60px">
              <v-btn
                class="ml-1"
                icon
                @click="$emit('click-checkbox',a.id,realList[0].attributeGroupId)"
              >
                <v-icon v-if="selectedAIdList.includes(a.id.toString())">
                  mdi-eye
                </v-icon>
                <v-icon
                  v-else
                  color="error lighten-2"
                >
                  mdi-eye-off
                </v-icon>
              </v-btn>
            </div>
          </template>
        </div>
      </draggable>

      <div
        v-for="(a,index) in newAdded"
        :key="a.key"
        class="d-flex align-center mb-1 pl-9"
      >
        <v-text-field
          v-model="a.name"
          :placeholder="$t('newAdd')"
          dense
          hide-details
          outlined
        />
        <div style="width: 16px"/>
        <div style="width: 120px">
          <v-text-field
            v-model="a.price"
            append-icon="mdi-cash"
            dense
            hide-details
            outlined
            placeholder="0.00"

            step="0.01"
            type="number"
          />
        </div>

        <div style="width: 60px">
          <v-btn
            :disabled="newAdded.length===1||(!a.price&&!a.name)"
            class="ml-1"
            icon
            @click="newAdded.splice(index,1)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <div class="pl-9 mt-4">
      <v-btn
        :disabled="realList.length+needToAdd.length===0"
        outlined
        @click="beforeSave"
      >
        <v-icon
          left
          size="20"
        >
          mdi-content-save
        </v-icon>
        {{ $t('save') }}
      </v-btn>
    </div>
    <v-dialog
      v-model="showAddToOtherDialog"
      persistent
      width="400px"
    >
      <v-card class="pa-4">
        <div class="text-h4">
          {{ $t('AddOneGroupJustNow') }}
        </div>
        <div class="text-caption">
          {{ $t('hopeThisOption') }}
        </div>
        <div
          class="text-body-1 mt-8 text-center"
          style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 24px;"
        >
          <v-card
            :loading="loading"
            color="#eee"
            elevation="0"
            @click="save(true)"
          >
            <v-responsive :aspect-ratio="1">
              <div
                class="d-flex align-center flex-column justify-center"
                style="height: 100%"
              >
                <template v-if="!loading">
                  <v-icon size="48">
                    mdi-view-grid-plus
                  </v-icon>
                  <div class="mt-4 text-body-1">
                    {{ $t('addToOtherDishes') }}
                  </div>
                </template>
                <template v-else>
                  <v-progress-circular
                    indeterminate
                    size="36"
                  />
                </template>
              </div>
            </v-responsive>
          </v-card>
          <v-card
            :loading="loading"
            color="#eee"
            elevation="0"
            @click="save(false)"
          >
            <v-responsive :aspect-ratio="1">
              <div
                class="d-flex align-center flex-column justify-center"
                style="height: 100%"
              >
                <template v-if="!loading">
                  <v-icon size="48">
                    mdi-plus
                  </v-icon>
                  <div class="mt-4 text-body-1">
                    {{ $t('justAddThisDish') }}
                  </div>
                </template>
                <template v-else>
                  <v-progress-circular
                    indeterminate
                    size="36"
                  />
                </template>
              </div>
            </v-responsive>
          </v-card>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import IKUtils from 'innerken-js-utils'
  import Attribute from '@/model/dish/Attribute'
  import Dish from '@/model/dish/Dish'
  import { flipAttributes } from '@/common/common'
  import { showSuccessMessage } from '@/common/utils'

  const defaultAttribute = {
    name: '',
    price: '',
  }
  let counter = 0
  export default {
    name: 'AttributeSortFragment',
    components: {
      draggable,
    },
    props: {
      titleName: {
        type: String,
      },
      selectedAIdList: {
        type: Array,
      },
      attributeGroup: {
        type: Object,
      },
      initialList: {
        type: Array,
      },
      itemId: {
        default: 'id',
        type: String,
      },
      itemSort: {
        default: 'sort',
        type: String,
      },
      dishId: {},
    },
    data: function () {
      return {
        loading: false,
        realList: [],
        newAdded: [this.createDefault()],
        showAddToOtherDialog: false,
      }
    },
    computed: {
      needToAdd () {
        return this.newAdded.filter(it => it.name)
      },
    },
    watch: {
      initialList: {
        immediate: true,
        handler (val) {
          if (this.initialList?.length) {
            this.realList = IKUtils.deepCopy(this.initialList)
            this.realList.sort((a, b) => {
              return a.value - b.value
            })
          }
        },
      },
      newAdded: {
        deep: true,
        handler (val) {
          const emptyNode = val.filter(it => !it.name && !it.price).length
          if (emptyNode === 0) {
            this.newAdded.push(this.createDefault())
          }
        },
      },
    },
    methods: {
      async beforeSave () {
        if (this.needToAdd.length > 0) {
          this.showAddToOtherDialog = true
        } else {
          await this.save(true)
        }
      },
      async save (addToOther = true) {
        this.loading = true
        this.needToAdd.forEach(it => {
          if (it.name && !it.price) {
            it.price = 0
          }
        })
        const attributeIdList = []
        for (const item of this.needToAdd) {
          item.attributeGroupId = this.attributeGroup.id
          item.printMod = item.name
          item.priceMod = item.price
          item.value = this.realList.length + 1
          item.dishesCategoryTypeId = 9
          item.isActive = 1
          attributeIdList.push((await Attribute.add(item)).id)
        }
        const reqs = this.realList.map(async (it, i) => {
          it.value = i + 1
          return await Attribute.edit(it)
        })
        await Promise.allSettled(reqs)
        if (!addToOther) {
          const dishes = await Dish.getList()
          const requests = dishes.map(async (it) => {
            for (const i of attributeIdList) {
              if (it.dishId !== this.dishId) {
                await flipAttributes(it.dishId, this.attributeGroup.id, i)
              }
            }
          })
          await Promise.allSettled(requests)
        }

        showSuccessMessage()
        this.loading = false
        this.$emit('save')
      },
      createDefault () {
        const obj = IKUtils.deepCopy(defaultAttribute)
        obj.key = counter++
        return obj
      },
    },
  }
</script>

<style scoped>

</style>
